module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "trips-page"
  }, [_c('div', {
    staticClass: "back-box",
    on: {
      "click": _vm.back
    }
  }, [_c('i', {
    staticClass: "fas fa-chevron-left fa-fw"
  }), _vm._v("\n    BACK\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "product-header"
  }, [_c('img', {
    staticClass: "product-image",
    attrs: {
      "src": _vm.tripData.details.ProductImage
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "product-info"
  }, [_c('div', {
    staticClass: "pd-title"
  }, [_vm._v(_vm._s(_vm.tripData.details.ProductName))]), _vm._v(" "), _c('div', {
    staticClass: "product-meta"
  }, [(_vm.tripData.details.Duration) ? _c('span', [_c('i', {
    staticClass: "far fa-clock fa-fw"
  }), _vm._v("\n          " + _vm._s(_vm.tripData.details.Duration) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.tripData.details.ProductCode) ? _c('span', [_c('i', {
    staticClass: "fas fa-tags fa-fw"
  }), _vm._v("\n          Product: " + _vm._s(_vm.tripData.details.ProductCode) + "\n        ")]) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "desc"
  }, [_vm._v(_vm._s(_vm.cleanTags(_vm.view.Description)))])])]), _vm._v(" "), _c('div', {
    staticClass: "section-title"
  }, [_c('svg', {
    attrs: {
      "fill": "none",
      "stroke": "currentColor",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      "d": "M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 110 4v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 110-4V7a2 2 0 00-2-2H5z"
    }
  })]), _vm._v("\n    Choose Your Experience\n  ")]), _vm._v(" "), _vm._l((_vm.tripData.list), function(ticket) {
    return _c('div', {
      staticClass: "ticket-card"
    }, [_c('div', {
      staticClass: "ticket-header"
    }, [_c('div', {
      staticClass: "ticket-title-wrap"
    }, [_c('div', {
      staticClass: "ticket-title"
    }, [_vm._v(_vm._s(ticket.gradeTitle))]), _vm._v(" "), _c('div', {
      staticClass: "ticket-subtitle"
    }, [_vm._v(_vm._s(ticket.gradeDescription))])]), _vm._v(" "), _c('div', {
      staticClass: "ticket-price"
    }, [_c('div', {
      staticClass: "label"
    }, [_vm._v("Total Price")]), _vm._v(" "), _c('div', {
      staticClass: "amount"
    }, [_c('span', {
      staticClass: "currency"
    }, [_vm._v(_vm._s(_vm.currencySymbol[_vm.currency.code]))]), _vm._v("\n          " + _vm._s(_vm.applyCurrency(ticket.Price, false)) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "per"
    }, [_vm._v("for " + _vm._s(ticket.TotalPax) + " travelers")])])]), _vm._v(" "), _c('div', {
      staticClass: "ticket-details"
    }, [_c('div', {
      staticClass: "ticket-detail"
    }, [_c('i', {
      staticClass: "far fa-calendar fa-fw"
    }), _vm._v("\n        " + _vm._s(_vm.formatDate(ticket.bookingDate)) + "\n      ")]), _vm._v(" "), _c('div', {
      staticClass: "ticket-detail"
    }, [_c('i', {
      staticClass: "fas fa-users fa-fw"
    }), _vm._v("\n        " + _vm._s(ticket.TotalPax) + " \n      ")]), _vm._v(" "), (ticket.available) ? _c('div', {
      staticClass: "ticket-detail"
    }, [_c('i', {
      staticClass: "far fa-check-circle fa-fw"
    }), _vm._v(" "), _c('span', {
      staticClass: "available"
    }, [_vm._v("Available")])]) : _vm._e(), _vm._v(" "), (ticket.langServices && ticket.langServices.length) ? _c('div', {
      staticClass: "ticket-detail"
    }, [_c('i', {
      staticClass: "fas fa-globe fa-fw"
    }), _vm._v("\n        " + _vm._s(ticket.langServices[0]) + _vm._s(ticket.langServices.length > 1 ? '+' : '') + "\n      ")]) : _vm._e()]), _vm._v(" "), (ticket.ageBandsRequired && ticket.ageBandsRequired.length) ? _c('div', {
      staticClass: "ticket-footer"
    }, [_c('div', {
      staticClass: "ticket-pax"
    }, [_vm._v("Min: "), _c('strong', [_vm._v(_vm._s(ticket.ageBandsRequired[0][0].minimumCountRequired))]), _vm._v(" • Max: "), _c('strong', [_vm._v(_vm._s(ticket.ageBandsRequired[0][0].maximumCountRequired))]), _vm._v(" per booking")]), _vm._v(" "), _c('button', {
      staticClass: "ticket-btn",
      on: {
        "click": function($event) {
          _vm.getBlockData(ticket)
        }
      }
    }, [_vm._v("Select")])]) : _vm._e()])
  })], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-c9ed1c6e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c9ed1c6e","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/D2DSightSeeing/trips/index.vue
// module id = 2141
// module chunks = 0